import { render, staticRenderFns } from "./DomeinlijstCard.vue?vue&type=template&id=901eb69e&"
import script from "./DomeinlijstCard.vue?vue&type=script&lang=js&"
export * from "./DomeinlijstCard.vue?vue&type=script&lang=js&"
import style0 from "./DomeinlijstCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports